export default __webpack_public_path__ + "static/media/invoice.d80ad8b8.svg";